var _defs, _use;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaption(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.626 5c-.994 0-1.82.825-1.82 1.82v3.306L2 12.277l1.807 2.152v3.306c0 .994.825 1.82 1.82 1.82H20.18c.994 0 1.819-.826 1.819-1.82V6.82C22 5.825 21.175 5 20.18 5H5.627zm0 1.82h14.555v10.915H5.626v-3.97l-1.249-1.488 1.25-1.487V6.82zm2.73 2.728v1.82h9.096v-1.82H8.355zm0 3.639v1.82h7.276v-1.82H8.355z",
    id: "caption-a"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#caption-a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaption);
export default __webpack_public_path__ + "static/media/caption.8ab16abf9f8c54d0007263d22dbf9b54.svg";
export { ForwardRef as ReactComponent };